var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"tooltip":_vm.message}},[_c('FontAwesomeIcon',{attrs:{"icon":['far', 'info-circle']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }